import React from "react";
import { Col, Form, Input, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";

const EditPasswordModal = ({ visible, onCancel, onOk, form, userToEdit, isLoading }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("edit_user_password", {
        user: !!userToEdit ? userToEdit.userFirstName + " " + userToEdit.userLastName : "",
      })}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText={t("save")}
      confirmLoading={isLoading}
      cancelText={t("close")}
    >
      <Form layout="vertical" form={form} onFinish={onOk}>
        <Row gutter={16}>
          <Col xs={24}>
            <Form.Item
              name={"password"}
              label={t("user.password")}
              rules={[
                {
                  required: true,
                  message: t("form.enter_password"),
                },
                () => ({
                  validator(rule, value) {
                    return value.length >= 6 ? Promise.resolve() : Promise.reject(t("form.password_length"));
                  },
                }),
              ]}
            >
              <Input.Password placeholder={t("user.password")} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditPasswordModal;
